import ContactThematicAreaService from '../../../../../services/contactThematicArea_service';

const ThematicAreas = (vm) => {
  const syncThematicAreasUpdate = async () => {
    try {
      const existing =
        (await ContactThematicAreaService.getAll({ FK_Contact: vm.userId })) ?? [];
      if (vm.logout(existing)) return false
      const oldSet = new Set(
        existing.map((r) => String(r.FK_ThematicArea).trim())
      );
      const newSet = new Set(
        (Array.isArray(vm.formDataArea) ? vm.formDataArea : []).map((s) => String(s).trim())
      );
      const toDelete = existing.filter(
        (r) => !newSet.has(String(r.FK_ThematicArea).trim())
      );
      const toCreate = [...newSet].filter((id) => !oldSet.has(id));
      await Promise.all(
        toDelete.map((r) => ContactThematicAreaService.delete(r.Id))
      );
      await Promise.all(
        toCreate.map((id) =>
          ContactThematicAreaService.create({
            FK_Contact: vm.userId,
            FK_ThematicArea: id,
          })
        )
      );
      return true
    } catch (e) {
      vm.message(e?.message || e, "error");
      return false
    }
  };

  return {
    syncThematicAreasUpdate,
  };
};

export default ThematicAreas;
